import React, {useEffect} from 'react'
import { renderRoute } from '../components/renderroutes'
import styles from "./mainview.css"
import {setAuth, useAuth, setToken, setRoles} from '../redux/auth'
import {useOpenPlan,setPlan,setOpenPlan, setSelectedSOPs} from '../redux/plan'
import {setSelectedModule} from '../redux/navigation'
import { getSOPS } from '../modules/db'

const handleClosedRefreshTab = () => {
  const timeNow = new Date().getTime()
  localStorage.setItem('closedTime', timeNow )
}

const timeDiffForLogout = 3600000

const Mainview = () => {
  useEffect( () => {
    const lastClosedTime = parseInt(localStorage.getItem('closedTime'))
    const timeNow = new Date().getTime()
    if( (timeNow - lastClosedTime) > timeDiffForLogout || isNaN(timeNow - lastClosedTime)  ){
      localStorage.removeItem('session')
      localStorage.removeItem('plan')
    }
    const session = JSON.parse(localStorage.getItem('session'))
    const currentPlan = JSON.parse(localStorage.getItem('plan'))
    if(session){
      setAuth(session.logged)
      setToken(session.token)
      setRoles(session.roles)
    }
    if(currentPlan && session){
      setOpenPlan(currentPlan.openPlan)
      setPlan(currentPlan.plan)
      setSelectedSOPs(currentPlan.plan.sops)
      setSelectedModule("Organize")
      getSOPS(session.token)
    }
    window.addEventListener('unload', handleClosedRefreshTab)

    return () => {
      window.removeEventListener('unload', handleClosedRefreshTab)
    }
  }, [localStorage.getItem('session')])

  const logged = useAuth()
  const op = useOpenPlan()
  return (
    <div className={!op && !logged ? styles.blueBack : styles.root}>
    { 
      <main className={styles.content}>
        { 
          !logged ?
            renderRoute({route:{name:'auth'}}):
            op ?
              renderRoute({route:{name:'sop'}}) : 
              renderRoute({route:{name:'planmanager'}})
        }
      </main>
    }
  </div>   
  );
}

export default Mainview;
